import {Component, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'app-full-page-spinner',
  templateUrl: './full-page-spinner.component.html',
  styleUrls: ['./full-page-spinner.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FullPageSpinnerComponent { }
